// import logo from "./logo.svg";
import "./App.css";
// import { Document } from "react-pdf";
let img = require("./assets/logo.jpeg");

function App() {
  return (
    <div className="App">
      <h1>PLUGIN</h1>
      {/* <image href="./assets/logo.jpeg" /> */}
      <img src={img} alt="" />
      <br />
      <br />
      <a href={`${window.location.origin}/android_lab.pdf`}>Book</a>
      <br />
      <br />
      <a href={`${window.location.origin}/android_lab2.pdf`}>Code</a>
    </div>
  );
}

export default App;
